import { Injectable } from '@angular/core';
import {
	HttpClient,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { exhaustMap, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import * as fromApp from 'src/app/store/app.reducer';
import * as AuthActions from 'src/app/store/auth/auth.actions';

import { AuthService } from '../services/auth.service';
import { noAuthApi } from '../conf/no-auth-api';
import { TokenData } from '../model/api/token-data';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor(
		public http: HttpClient,
		private store: Store<fromApp.AppState>,
		private authService: AuthService
	) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (noAuthApi(req.url)) {
			return next.handle(req);
		}
		return this.getValidToken().pipe(
			take(1),
			exhaustMap(tokenData => {
				if (tokenData) {
					const newReq = this.addToken(req, tokenData.access_token);
					return next.handle(newReq);
				} else {
					console.log('INTERCEPT NO VALID TOKEN')
					this.store.dispatch(AuthActions.authLogout());
					return next.handle(req);
				}
			})
		);
	}


	addToken(request: HttpRequest<any>, token: string) {
		return request.clone({
			setHeaders: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	getValidToken(): Observable<TokenData | null> {
		return this.store.select('auth').pipe(
			map(authState => authState.tokenData),
			map(tokenData => {
				if (tokenData) {
					if (!this.authService.isTokenValid(tokenData.access_token)) {
						return null;
					}
					return tokenData;
				}
				return null;
			})
		);
	}
}
